<template>
  <div id="app">
    <main class="app__container">
      <div v-if="$route.meta.backButton" class="app__nav">
        <el-button
          type="info"
          class="app__nav-btn"
          @click="navigateBack">
          {{ backText }}
        </el-button>
      </div>
      <router-view/>
    </main>
    <footer class="app__footer">© SAT. Knowledge</footer>
  </div>
</template>

<script>
import { navigateTool } from '@/utils/sharefunc'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['isLogin']),
    backButton () {
      return this.$route.meta.backButton
    },
    backText () {
      switch (this.backButton) {
        case 'logout':
          return '登出'
        case 'tool':
          return '回首頁'
        default:
          return ''
      }
    }
  },
  created () {
    if (this.isLogin) {
      this.$store.dispatch('getUser')
    }
  },
  methods: {
    navigateBack () {
      if (this.backButton === 'logout') {
        this.$store.dispatch('logout')
        this.$router.push({ path: '/' })
        return
      }

      navigateTool(this.backButton)
    }
  }
}
</script>
